import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import loaderStyles from '../Loader/loader.css';
import GBColorPropType from '../../prop-types/GBColor';
import SizePropType from '../../prop-types/Size';
import styles from './button.css';
var cx = classnames.bind(styles);

function Button(_ref) {
  var Element = _ref.as,
      className = _ref.className,
      color = _ref.color,
      bordered = _ref.bordered,
      cta = _ref.cta,
      rounded = _ref.rounded,
      fluid = _ref.fluid,
      role = _ref.role,
      size = _ref.size,
      icon = _ref.icon,
      wide = _ref.wide,
      loading = _ref.loading,
      link = _ref.link,
      uppercase = _ref.uppercase,
      primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      props = _objectWithoutProperties(_ref, ["as", "className", "color", "bordered", "cta", "rounded", "fluid", "role", "size", "icon", "wide", "loading", "link", "uppercase", "primary", "secondary", "tertiary"]);

  var branded = !!(primary || secondary || tertiary);
  var classes = cx('button', size, !branded && color, {
    bordered: !branded && bordered,
    link: link,
    cta: cta,
    rounded: !branded && rounded,
    fluid: fluid,
    icon: icon,
    wide: wide,
    uppercase: !branded && uppercase,
    primary: primary,
    secondary: secondary,
    tertiary: tertiary
  }, loading && loaderStyles.inlineLoader, loading && loaderStyles.hiddenText, loading && !branded && color !== 'white' && !bordered && loaderStyles.inverse, className);
  return React.createElement(Element, _extends({
    className: classes,
    role: role
  }, props));
}

Button.displayName = 'Button';
Button.propTypes = {
  /** String or component to replace the tag name */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Button color */
  color: GBColorPropType,

  /** Boolean indicating whether the button is bordered */
  bordered: PropTypes.bool,

  /** Boolean to bold the button text */
  cta: PropTypes.bool,

  /** Boolean indicating to round off the corners */
  rounded: PropTypes.bool,

  /** Boolean indicating to fill the width of the container */
  fluid: PropTypes.bool,

  /** Role for accessibility purposes */
  role: PropTypes.string,

  /** Button size */
  size: SizePropType,

  /** Boolean indicating if the button contains an icon */
  icon: PropTypes.bool,

  /** Boolean indicating if the button should have additional horizontal padding */
  wide: PropTypes.bool,

  /** Boolean indicating if a loading indicator should display */
  loading: PropTypes.bool,

  /** Boolean indicating if a button should display like a link */
  link: PropTypes.bool,

  /** Boolean to indicate if the button text should be uppercase */
  uppercase: PropTypes.bool,

  /** Boolean to indicate if the button text should assume primary styles */
  primary: PropTypes.bool,

  /** Boolean to indicate if the button text should assume secondary styles */
  secondary: PropTypes.bool,

  /** Boolean to indicate if the button text should assume tertiary styles */
  tertiary: PropTypes.bool
};
Button.defaultProps = {
  as: 'button',
  className: undefined,
  color: 'grey',
  bordered: false,
  cta: false,
  rounded: true,
  fluid: false,
  role: 'button',
  size: undefined,
  icon: false,
  wide: false,
  loading: false,
  link: false,
  uppercase: false,
  primary: false,
  secondary: false,
  tertiary: false
};
export default React.memo(Button);